import React, { FC, useState } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { TitleOnBoarding } from '../../../components/TitleOnBoarding'
// import { GreenButton } from '../../../components/Buttons/GreenButton'
// import { routes } from '../../../constants/routes'

const useStyles = makeStyles({
  root: {
    margin: '0 auto',
    maxWidth: 834,
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 'bold',
  },
  container: {
    width: '632px',
    textAlign: 'center',
  },
})

interface ISuccesfullyCompleted {
  title: string
}

export const SuccesfullyCompleted: FC<ISuccesfullyCompleted> = ({ title }) => {
  const classes = useStyles()
  const [activeStep] = useState(10)

  return (
    <Grid className={classes.root} container direction="column" alignItems="center">
      <Grid item container className={classes.container} direction="column" alignItems={'center'}>
        <TitleOnBoarding title={title} activeStep={activeStep} />
      </Grid>
      {/* <GreenButton text="LOGIN" type="button" width={321} mt={72} noHistory={true} href={routes.LOGIN} /> */}
    </Grid>
  )
}
